import { dongpilTalkio, theisTalkio, woongTalkio } from "server/check-super-admin-access";
import { SiteConfig } from "../../types";
import { _config as defaultSiteConfig } from "../../default/config";

export const _config: SiteConfig = {
  isDefault: false,
  enableStripeBilling: false,
  serviceName: "Talkio AI",
  publicUrl: "https://ko.talkio.ai",
  appLogoPath: "/partner/korea/logo.png",
  appLogoHeight: "5px",
  landingLogoPath: "/partner/korea/logo.png",
  landingLogoHeight: "25px",
  favicon: "/favicon.png",
  showTidio: false,
  showLanguageGuides: true,
  adminEmail: "help@talkio.co.kr",
  reviewLink: "https://senja.io/p/talkio/r/9XyUN8",
  overrideLanding: true,
  superAdminIds: [dongpilTalkio, woongTalkio, theisTalkio],
  authErrorPath: "https://kr.talkio.ai/hub/auth/logout/",
  authSignInPath: "https://kr.talkio.ai/hub/auth/login/",
  authSessionDurationHours: 2,
  supportLink: "https://kr.talkio.ai/hub/user/help_reg/",
  hideSignUpLink: true,
  hidePrivacyTosSection: true,
  hideDiscordLink: true,
  uiLanguage: "ko-KR",
  enableRecordingPlayback: true,
  settingsShowLiveFeedback: false,
  disableCategoryRecommendations: true,
  displayOrientalView: true,
  pwaIcons: [
    {
      src: "/icons/icon-192x192.png",
      type: "image/png",
      sizes: "192x192",
    },
    {
      src: "/icons/icon-256x256.png",
      type: "image/png",
      sizes: "256x256",
    },
    {
      src: "/icons/icon-512x512.png",
      type: "image/png",
      sizes: "512x512",
    },
  ],
  siteColors: {
    special: {
      homeView4BackgroundColor: "#4193F1",
      homeView4ButtonBackgroundColor: "#0D67C7",
      homeView4TextColor: "white",
    },
  },
  customVoiceTutors: [
    ...(defaultSiteConfig.customVoiceTutors || []),
    {
      langCode: "vi-VN",
      // Speechify format: speechify-languageCode-[voice_id]
      id: "speechify-vi-VN-[42247946-2572-40d3-9c65-54f363893ad2]",
      externalId: "42247946-2572-40d3-9c65-54f363893ad2",
      avatarName: "Siwon Vi",
      displayName: "Siwon Vi",
      gender: "Female",
      bio: "A special and beautiful voice in Vietnamese.",
      customImageUrl: "/partner/korea/avatars/vietnamese.jpeg",
      restrictedToOrganizationPattern: "siwon",
    },

    {
      langCode: "es-ES",
      // Speechify format: speechify-languageCode-[voice_id]
      id: "speechify-es-ES-[d7152f27-a57d-4e37-b577-68fe59ed4d79]",
      externalId: "d7152f27-a57d-4e37-b577-68fe59ed4d79",
      avatarName: "Siwon Es",
      displayName: "Siwon Es",
      gender: "Female",
      bio: "A special and beautiful voice in Spanish.",
      customImageUrl: "/partner/korea/avatars/spanish.jpeg",
      restrictedToOrganizationPattern: "siwon",
    },

    {
      langCode: "ja-JP",
      // Speechify format: speechify-languageCode-[voice_id]
      id: "speechify-ja-JP-[bf8f0ca2-cc07-427e-8672-ba11254710b0]",
      externalId: "bf8f0ca2-cc07-427e-8672-ba11254710b0",
      avatarName: "Siwon Ja",
      displayName: "Siwon Ja",
      gender: "Female",
      bio: "A special and beautiful voice in Japanese.",
      customImageUrl: "/partner/korea/avatars/japanese.jpeg",
      restrictedToOrganizationPattern: "siwon",
    },
  ],
};
